var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('YFooter',{attrs:{"brand":"quero-bolsa"}},[_c('YFooter.Above',{attrs:{"has-full-visibility":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }